import React, { useState } from 'react';
import toast from 'react-hot-toast';

import HomepageLayoutRenderer from '../sections/HomepageLayoutRenderer';
import { usePublicSiteShellSettings } from '../../hooks/usePublicSiteShellSettings';
import type { EnquiryFormData, SelectedVase } from '../../types';
import type { HomepageLayoutContent } from '../sections/sectionRegistry';
import PublicSiteChrome from './PublicSiteChrome';
import { shouldSuppressShellProgressForLayout } from '../../lib/progressContent';

type PublicSitePageProps = {
  pageKey: string;
  fallbackLayout?: HomepageLayoutContent;
};

const PublicSitePage: React.FC<PublicSitePageProps> = ({ pageKey, fallbackLayout }) => {
  const { settings: shellSettings } = usePublicSiteShellSettings('published');
  const [showThankYou, setShowThankYou] = useState(false);
  const [suppressShellProgress, setSuppressShellProgress] = useState(false);

  const handleVaseSelection = (vase: SelectedVase) => {
    const targetId = shellSettings.productSelectScrollTargetId;
    if (!targetId) return;
    if (typeof window !== 'undefined') {
      window.setTimeout(() => {
        document.getElementById(targetId)?.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 120);
    }
  };

  const handleEnquirySubmit = (formData: EnquiryFormData) => {
    setShowThankYou(true);
  };

  return (
    <div className="bg-stone-50 font-sans text-stone-900 dark:bg-stone-900 dark:text-stone-100">
      <HomepageLayoutRenderer
        pageKey={pageKey}
        fallbackLayout={fallbackLayout}
        onLayoutResolved={(layout) => {
          setSuppressShellProgress(shouldSuppressShellProgressForLayout(layout));
        }}
        onSelectVase={handleVaseSelection}
        onEnquirySubmit={handleEnquirySubmit}
        enquiryEmailTo={shellSettings.enquiryEmailTo}
      />
      <PublicSiteChrome
        pageKey={pageKey}
        shellSettings={shellSettings}
        showThankYou={showThankYou}
        onCloseThankYou={() => setShowThankYou(false)}
        suppressProgress={suppressShellProgress}
      />
    </div>
  );
};

export default PublicSitePage;
